import React, { useState, useEffect } from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as Yup from "yup";
import { CircularProgress } from "@material-ui/core";
import { addTokenTransactionAsync } from "../../../token_transactions/redux/tokenTransactionApi";
import { UserManagementActions } from "../../redux/userManagementAction";
import { getAllUsersAsync } from "../../redux/userManagementApi";

const AddToken = ({ showAddToken, setShowAddToken, selectedUser }) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    searchText,
    skip,
    limit,
    isJury,
    dir,
    searchBy,
  } = useSelector((state) => state.userManagement, shallowEqual);

  const initialValues = {
    amount: "",
  };

  // Formik validation schema
  const addTokenSchema = Yup.object().shape({
    amount: Yup.number()
      .typeError("Amount must be a number")
      .positive("Amount must be positive")
      .integer("Amount must be a whole number (no decimals)")
      .required("Please enter amount"),
  });

  const onHideAddToken = () => {
    setShowAddToken(false);
  };

  return (
    <>
      <Modal
        size="md"
        show={showAddToken}
        onHide={() => onHideAddToken()}
        centered
        className="def_modal delete_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">
            Add Token
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={addTokenSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setSubmitting(true);

              // Check if user is selected
              if (!selectedUser?._id) {
                alert("Please select a user first");
                setSubmitting(false);
                return;
              }

              // Ensure user_id is included in the API call even though it's not in the form
              const apiData = {
                ...values,
                user_id: selectedUser._id,
              };

              dispatch(addTokenTransactionAsync(apiData));
              setSubmitting(false);
              resetForm();
              onHideAddToken();

              // Refresh user list after a short delay to ensure API call completes
              setTimeout(() => {
                dispatch(
                  getAllUsersAsync(
                    searchText,
                    skip,
                    limit,
                    isJury.value,
                    dir,
                    searchBy
                  )
                );
              }, 1000);
            }}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <Form autoComplete="off" onSubmit={handleSubmit}>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="form-group">
                      <label className="form-label text-white font-size-16px inter-font font-weight-normal">
                        Username
                      </label>
                      <input
                        placeholder="Username"
                        type="text"
                        name="username"
                        className="form-control re_inputRouded border-less-input"
                        value={selectedUser?.userName || ""}
                        disabled={true}
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label text-white font-size-16px inter-font font-weight-normal">
                        Amount
                      </label>
                      <input
                        placeholder="Enter Amount (numbers only, no decimals)"
                        type="number"
                        name="amount"
                        className={
                          errors.amount && touched.amount
                            ? "form-control re_inputRouded is-invalid border-less-input"
                            : "form-control re_inputRouded border-less-input"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.amount}
                        step="1"
                        min="1"
                      />
                      {touched.amount && errors.amount ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.amount}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group mb-0 mt-4">
                      <div className="mb-1 mt-2">
                        {isSubmitting || isLoading ? (
                          <div className="ml-3 basic-verification-loader text-center">
                            <CircularProgress />
                          </div>
                        ) : (
                          <Button
                            variant="blue"
                            className="px-5 defpddng spinnerBtn btn_new add-avtar-btn d-flex justify-content-center"
                            size="lg"
                            type="submit"
                            disabled={isSubmitting || isLoading}
                          >
                            Add Token
                          </Button>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddToken;
